const initialGeolocation = {
  longitude: undefined,
  latitude: undefined,
  geocode: undefined,
};

export default initialGeolocation;
